import Badge from '@mui/material/Badge';
import MenuIcon from '@mui/icons-material/Menu';
import { makeStyles } from 'tss-react/mui';
import { useInboxMessages } from 'features/inboxMessages/hooks/useInboxMessages';
import { getDenseResponsiveFontSize } from 'theme/watchdutyTheme.utils';

const useStyles = makeStyles()(() => ({
  icon: {
    width: 24, // hard-coding to prevent iOS Dynamic Type from resizing this
    height: 24,
  },
  badge: {
    fontSize: getDenseResponsiveFontSize('0.75rem'),
  },
}));

export const MenuBadge = (): JSX.Element => {
  const { classes } = useStyles();
  const { unreadMessages } = useInboxMessages();

  return (
    <Badge
      badgeContent={unreadMessages}
      color="error"
      classes={{ badge: classes.badge }}
    >
      <MenuIcon className={classes.icon} />
    </Badge>
  );
};
